import styles from "./ReferralTermAndConditions.module.scss";

interface ReferralTermEnProps {
  referralPayout: Money;
  withdrawalMethods: WithdrawalMethods;
}

const ReferralTermEn: React.FC<ReferralTermEnProps> = ({
  referralPayout,
  withdrawalMethods,
}) => {
  return (
    <main className={styles.container}>
      <h1>Referral Program Terms</h1>
      <strong>
        A &quot;qualified referral&quot; refers to the status of your referral
        after completion of the following:
      </strong>
      <ol>
        <li>Signs up via your unique referral code,</li>
        <li>
          Has earned the stated amount of confirmed cashback by shopping through
          ShopCash
        </li>
      </ol>

      <strong>For more details on each point above:</strong>
      <ol>
        <li>Your friend must sign up with your code</li>
        <li>
          Referrals&apos; first purchase must be a legitimate order that is
          non-stackable with other New Customer promotions
        </li>
        <li>
          Orders that do not earn Cashback, or any cancelled, refunded or
          exchanged orders will not be eligible for this programme.
        </li>
        <li>
          Your bonus of {referralPayout?.currencyCode} {referralPayout?.amount}{" "}
          will be tracked when your friend signs up. Your bonus will be credited
          into your ShopCash account only when your friend earns the minimum
          stated confirmed cashback.
        </li>
        <li>
          ShopCash reserves the right in its sole and absolute discretion to
          amend and vary the terms and conditions as set out above, as well as
          to disqualify any user at any point of time.
        </li>
        <li>
          To withdraw the cashback you must be an active user with a minimum
          confirmed cashback of at least{" "}
          {withdrawalMethods?.bankTransfer?.minimum?.currencyCode}{" "}
          {withdrawalMethods?.bankTransfer?.minimum?.amount} from shopping
          through ShopCash.
        </li>
      </ol>

      <h3>Restrictions</h3>
      <strong>
        The following is a non-exhaustive list of activities that are not
        permitted and that will disqualify you from earning referral bonuses:
      </strong>
      <p>(i) self-referral,</p>
      <p>
        (ii) posting your referral code on any ShopCash merchant&apos;s Facebook
        or forum page,
      </p>
      <p>
        (iii) placement of our logos or mention of our trademarks or tradenames
        in any ad text, extensions or banner ads,
      </p>
      <p>
        (iv) keyword bidding for the purpose of generating traffic to pages
        containing your referral code, and
      </p>
      <p>
        (v) any similar activity determined by ShopCash in its sole discretion
        to be inconsistent with the purpose of ShopCash&apos;s Refer-a-Friend
        Programme.
      </p>

      <p>
        ShopCash reserves the right to alter the terms and conditions of this
        promotion. Any infringement of the above terms and conditions would
        result in the loss of all bonuses. Repeat offences would result in the
        closure of your ShopCash account. You are responsible for any applicable
        taxes. This referral program is open only to individuals who are at
        least eighteen (18) years of age.
      </p>
      <h3>Termination</h3>
      <p>
        We reserve the right to suspend or terminate the Referral Program or to
        change these Referral Program Terms at any time and for any reason in
        our sole discretion.
      </p>
    </main>
  );
};

export default ReferralTermEn;
